import { useCallback, useEffect, useState } from 'react';

const useScrollPosition = (scrollContainer) => {
    const [scrollPosition, setScrollPosition] = useState(scrollContainer.scrollTop);

    const handleScroll = useCallback(() => {
        const position = scrollContainer.scrollTop;
        setScrollPosition(position);
    }, [scrollContainer]);

    useEffect(() => {
        scrollContainer.addEventListener('scroll', handleScroll, { passive: true });

        return () => {
            scrollContainer.removeEventListener('scroll', handleScroll);
        };
    }, [scrollContainer, handleScroll]);

    return scrollPosition;
};

export default useScrollPosition;
